
import { useState } from 'react';
import AdminLayout from '../../../components/feature/AdminLayout';

export default function AdminAnalytics() {
  const [dateRange, setDateRange] = useState('30days');
  const [activeTab, setActiveTab] = useState('overview');
  const [stats] = useState({
    totalCertificates: 1247,
    totalStudents: 892,
    monthlyGrowth: 15.3,
    revenue: 2450000,
    downloadCount: 3421,
    completionRate: 87.5,
    averageScore: 84.2,
    popularCourses: [
      { name: '디지털 마케팅 전문가 과정', count: 324, percentage: 26, completionRate: 92, avgScore: 88 },
      { name: 'AI 활용 비즈니스 전략', count: 298, percentage: 24, completionRate: 89, avgScore: 85 },
      { name: '데이터 분석 실무', count: 245, percentage: 20, completionRate: 85, avgScore: 82 },
      { name: '프로젝트 관리 전문가', count: 189, percentage: 15, completionRate: 91, avgScore: 87 },
      { name: '클라우드 컴퓨팅 기초', count: 191, percentage: 15, completionRate: 83, avgScore: 79 }
    ],
    monthlyData: [
      { month: '1월', certificates: 89, revenue: 178000, students: 76, completion: 85 },
      { month: '2월', certificates: 124, revenue: 248000, students: 98, completion: 87 },
      { month: '3월', certificates: 156, revenue: 312000, students: 134, completion: 89 },
      { month: '4월', certificates: 198, revenue: 396000, students: 167, completion: 88 },
      { month: '5월', certificates: 234, revenue: 468000, students: 201, completion: 90 },
      { month: '6월', certificates: 267, revenue: 534000, students: 234, completion: 87 }
    ],
    studentDemographics: {
      ageGroups: [
        { range: '20-29세', count: 234, percentage: 26 },
        { range: '30-39세', count: 312, percentage: 35 },
        { range: '40-49세', count: 198, percentage: 22 },
        { range: '50세 이상', count: 148, percentage: 17 }
      ],
      industries: [
        { name: 'IT/소프트웨어', count: 267, percentage: 30 },
        { name: '마케팅/광고', count: 189, percentage: 21 },
        { name: '제조업', count: 156, percentage: 17 },
        { name: '금융/보험', count: 134, percentage: 15 },
        { name: '기타', count: 146, percentage: 17 }
      ]
    },
    certificateStatus: {
      issued: 1247,
      pending: 23,
      failed: 45,
      revoked: 8
    },
    topPerformers: [
      { name: '김민수', course: '디지털 마케팅', score: 98, date: '2024-01-15' },
      { name: '이지영', course: 'AI 비즈니스', score: 96, date: '2024-01-14' },
      { name: '박준호', course: '데이터 분석', score: 95, date: '2024-01-13' },
      { name: '최수진', course: '프로젝트 관리', score: 94, date: '2024-01-12' }
    ]
  });

  const exportReport = () => {
    alert('분석 리포트를 Excel 파일로 다운로드합니다.');
  };

  const tabs = [
    { id: 'overview', name: '전체 현황', icon: 'ri-dashboard-line' },
    { id: 'courses', name: '과정별 분석', icon: 'ri-book-line' },
    { id: 'students', name: '학습자 분석', icon: 'ri-user-line' },
    { id: 'performance', name: '성과 분석', icon: 'ri-bar-chart-line' }
  ];

  return (
    <AdminLayout>
      <div className="p-6">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">교육 운영 분석</h1>
            <p className="text-sm text-gray-500">교육 과정 운영 현황과 학습자 성과를 종합 분석하세요</p>
          </div>
          <div className="flex space-x-3">
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8"
            >
              <option value="7days">최근 7일</option>
              <option value="30days">최근 30일</option>
              <option value="90days">최근 90일</option>
              <option value="1year">최근 1년</option>
            </select>
            <button
              onClick={exportReport}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line mr-2"></i>
              리포트 다운로드
            </button>
          </div>
        </div>

        {/* 탭 네비게이션 */}
        <div className="mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-2 px-1 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <i className={`${tab.icon} mr-2`}></i>
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* 전체 현황 탭 */}
        {activeTab === 'overview' && (
          <div>
            {/* 주요 지표 */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">총 수료자</p>
                    <p className="text-2xl font-bold text-gray-900">{stats.totalStudents.toLocaleString()}</p>
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className="ri-user-line text-xl text-blue-600"></i>
                  </div>
                </div>
                <div className="mt-4 flex items-center">
                  <span className="text-green-600 text-sm font-medium">+{stats.monthlyGrowth}%</span>
                  <span className="text-gray-500 text-sm ml-2">전월 대비</span>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">발급 증명서</p>
                    <p className="text-2xl font-bold text-gray-900">{stats.totalCertificates.toLocaleString()}</p>
                  </div>
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-file-text-line text-xl text-green-600"></i>
                  </div>
                </div>
                <div className="mt-4 flex items-center">
                  <span className="text-green-600 text-sm font-medium">+12.8%</span>
                  <span className="text-gray-500 text-sm ml-2">전월 대비</span>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">수료율</p>
                    <p className="text-2xl font-bold text-gray-900">{stats.completionRate}%</p>
                  </div>
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                    <i className="ri-trophy-line text-xl text-purple-600"></i>
                  </div>
                </div>
                <div className="mt-4 flex items-center">
                  <span className="text-green-600 text-sm font-medium">+2.3%</span>
                  <span className="text-gray-500 text-sm ml-2">전월 대비</span>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">평균 점수</p>
                    <p className="text-2xl font-bold text-gray-900">{stats.averageScore}점</p>
                  </div>
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                    <i className="ri-star-line text-xl text-orange-600"></i>
                  </div>
                </div>
                <div className="mt-4 flex items-center">
                  <span className="text-green-600 text-sm font-medium">+1.5점</span>
                  <span className="text-gray-500 text-sm ml-2">전월 대비</span>
                </div>
              </div>
            </div>

            {/* 월별 트렌드 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-6">월별 수료자 현황</h3>
                <div className="space-y-4">
                  {stats.monthlyData.map((data, index) => (
                    <div key={index} className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                        <span className="text-sm font-medium text-gray-900">{data.month}</span>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="text-sm text-gray-600">{data.students}명</span>
                        <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                          수료율 {data.completion}%
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-6">증명서 발급 상태</h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <i className="ri-check-line text-green-600"></i>
                      <span className="text-sm font-medium text-gray-900">발급 완료</span>
                    </div>
                    <span className="text-lg font-bold text-green-600">{stats.certificateStatus.issued}</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <i className="ri-time-line text-yellow-600"></i>
                      <span className="text-sm font-medium text-gray-900">발급 대기</span>
                    </div>
                    <span className="text-lg font-bold text-yellow-600">{stats.certificateStatus.pending}</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-red-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <i className="ri-close-line text-red-600"></i>
                      <span className="text-sm font-medium text-gray-900">발급 실패</span>
                    </div>
                    <span className="text-lg font-bold text-red-600">{stats.certificateStatus.failed}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 과정별 분석 탭 */}
        {activeTab === 'courses' && (
          <div>
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">과정별 성과 분석</h3>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-3 px-4 font-medium text-gray-900">과정명</th>
                      <th className="text-center py-3 px-4 font-medium text-gray-900">수료자</th>
                      <th className="text-center py-3 px-4 font-medium text-gray-900">수료율</th>
                      <th className="text-center py-3 px-4 font-medium text-gray-900">평균 점수</th>
                      <th className="text-center py-3 px-4 font-medium text-gray-900">비율</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.popularCourses.map((course, index) => (
                      <tr key={index} className="border-b border-gray-100">
                        <td className="py-4 px-4">
                          <div className="font-medium text-gray-900">{course.name}</div>
                        </td>
                        <td className="py-4 px-4 text-center">
                          <span className="font-medium text-gray-900">{course.count}명</span>
                        </td>
                        <td className="py-4 px-4 text-center">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            course.completionRate >= 90 ? 'bg-green-100 text-green-800' :
                            course.completionRate >= 85 ? 'bg-yellow-100 text-yellow-800' :
                            'bg-red-100 text-red-800'
                          }`}>
                            {course.completionRate}%
                          </span>
                        </td>
                        <td className="py-4 px-4 text-center">
                          <span className="font-medium text-gray-900">{course.avgScore}점</span>
                        </td>
                        <td className="py-4 px-4 text-center">
                          <div className="flex items-center justify-center">
                            <div className="w-16 bg-gray-200 rounded-full h-2 mr-2">
                              <div 
                                className="bg-blue-600 h-2 rounded-full" 
                                style={{ width: `${course.percentage}%` }}
                              ></div>
                            </div>
                            <span className="text-sm text-gray-600">{course.percentage}%</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* 학습자 분석 탭 */}
        {activeTab === 'students' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">연령대별 분포</h3>
              <div className="space-y-4">
                {stats.studentDemographics.ageGroups.map((group, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                      <span className="text-sm font-medium text-gray-900">{group.range}</span>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="w-24 bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-blue-600 h-2 rounded-full" 
                          style={{ width: `${group.percentage}%` }}
                        ></div>
                      </div>
                      <span className="text-sm text-gray-600 w-12 text-right">{group.count}명</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">업종별 분포</h3>
              <div className="space-y-4">
                {stats.studentDemographics.industries.map((industry, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-purple-600 rounded-full"></div>
                      <span className="text-sm font-medium text-gray-900">{industry.name}</span>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="w-24 bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-purple-600 h-2 rounded-full" 
                          style={{ width: `${industry.percentage}%` }}
                        ></div>
                      </div>
                      <span className="text-sm text-gray-600 w-12 text-right">{industry.count}명</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 성과 분석 탭 */}
        {activeTab === 'performance' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">우수 수료자</h3>
              <div className="space-y-4">
                {stats.topPerformers.map((performer, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <span className="text-sm font-bold text-blue-600">#{index + 1}</span>
                      </div>
                      <div>
                        <div className="font-medium text-gray-900">{performer.name}</div>
                        <div className="text-sm text-gray-500">{performer.course}</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-bold text-lg text-blue-600">{performer.score}점</div>
                      <div className="text-xs text-gray-500">{performer.date}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">수익 분석</h3>
              <div className="space-y-6">
                <div className="text-center p-6 bg-green-50 rounded-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
                  </div>
                  <div className="text-3xl font-bold text-green-600 mb-2">₩{stats.revenue.toLocaleString()}</div>
                  <div className="text-sm text-gray-600">총 결제 수익</div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-4 bg-blue-50 rounded-lg">
                    <div className="text-xl font-bold text-blue-600">₩{Math.round(stats.revenue / stats.totalCertificates).toLocaleString()}</div>
                    <div className="text-xs text-gray-600">증명서당 평균 수익</div>
                  </div>
                  <div className="text-center p-4 bg-purple-50 rounded-lg">
                    <div className="text-xl font-bold text-purple-600">₩{Math.round(stats.revenue / stats.totalStudents).toLocaleString()}</div>
                    <div className="text-xs text-gray-600">학습자당 평균 수익</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
